// eslint-disable-next-line import/prefer-default-export
export const PIECES_JOINTES = {
  attachments: 'Pièces jointes',
  modal: {
    title: 'Pièces jointes',
    add: 'Ajouter',
    cancel: 'Annuler',
    addYourAttachments: 'Ajouter vos pièces jointes',
    formatAndMaxSize: 'Taille maximale: 10 Mo',
    fileName: 'Nom du fichier',
    type: 'Type',
    description: 'Description',
    selectType: 'Sélectionner un type',
    infoTypePj: 'Attention, les pièces jointes ajoutées avec ce type ne seront plus supprimable',
  },
  table: {
    fileName: 'Nom du fichier',
    type: 'Type',
    description: 'Description',
  },
  errors: {
    typeNotAllowed: 'Ce type de piece jointe n\'est pas accepté',
    fileTooBig: 'Ajout impossible. La taille du fichier doit être inférieure < à {maxSize}Mo',
    fileWithNameTooBig: 'Ajout impossible de {fileName}. La taille du fichier doit être inférieure < à {maxSize}Mo',
  },
  messages: {
    deleteSuccess: 'Pièce jointe supprimée avec succès',
    insertSuccess: 'Pièce jointe ajoutée avec succès',
    deleteError: 'Cette pièce jointe est non supprimable',
  },
  aucunAttachement: 'Aucune pièce jointe',
  addAttachement: 'Ajouter une pièce jointe',
  impossibleDeSupprimerPj: 'Impossible de supprimer la pièce jointe car elle est non supprimable',
  historique: 'Photo précédente',
};
